import {Component, EventEmitter, Input, OnDestroy, OnInit, Optional, Output, Self} from '@angular/core';
import {MatFormFieldControl} from '@angular/material/form-field';
import {TdoInputComponent} from '../tdo-input/tdo-input.component';
import {ControlValueAccessor, NgControl} from '@angular/forms';
import {noop, Subject} from 'rxjs';

@Component({
  selector: 'tdo-date-input',
  templateUrl: './tdo-date-input.component.html',
  styleUrls: ['./tdo-date-input.component.scss'],
  providers: [
    {provide: MatFormFieldControl, useExisting: TdoInputComponent},
    // {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MatFormFieldControl), multi: true}
  ]
})
export class TdoDateInputComponent implements OnInit, OnDestroy {
  @Input() widthString: string = '200px';
  @Input() placeholder: string = '';
  @Input() placeholderPosition: string = 'inline'; // inline / above
  @Input() isRequired: boolean = false;
  @Input() valueAsDate: Date;
  @Input() isAllowBlank: boolean = false;
  @Input() cypressControlIdentifier: string = 'ctrlTdoDateInput';

  // Overrides
  @Input() autofilled: boolean;
  @Input() controlType: string;
  @Input() disabled: boolean;
  @Input() empty: boolean;
  @Input() errorState: boolean;
  @Input() focused: boolean;
  @Input() id: string;
  @Input() required: boolean;
  @Input() shouldLabelFloat: boolean;
  @Input() userAriaDescribedBy: string;
  @Input() maxCharacters: number = 0;

  @Output() dateChanged: EventEmitter<Date> = new EventEmitter<Date>();

  stateChanges = new Subject<void>();

  innerValue: Date;
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    //
    if (this.valueAsDate && this.valueAsDate instanceof Date && !isNaN(this.valueAsDate.valueOf())) {
      this.innerValue = this.valueAsDate;
      // // testing
      // if (this.valueAsDate === new Date()) {
      //   this.innerValue = '';
      // }
    } else {
      if (!this.isAllowBlank) {
        this.innerValue = new Date();
        this.dateChanged.emit(this.innerValue);
      }
    }
  }

  ngOnDestroy() {
    this.stateChanges.complete();
  }

  onContainerClick(event: MouseEvent): void {
    //
  }

  setDescribedByIds(ids: string[]): void {
    //
  }

  get value(): any {
    return this.innerValue;
  }

  @Input()
  set value(v: any) {
    if (v !== this.innerValue && v !== null && v !== undefined) {
      this.innerValue = v;
      this.onChangeCallback(v);
      this.stateChanges.next();
      // this.change.emit(this.value);
    }
  }

  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  onInputFinished(event: any) {
    this.dateChanged.emit(event);
  }

  updateDate(event: any) {
    this.innerValue = event.target.valueAsDate;
    this.valueAsDate = event.target.valueAsDate;
    this.dateChanged.emit(event.target.valueAsDate);
  }

  onFocusReceived(event: FocusEvent) {

    if ( this.innerValue  == null) {
      this.innerValue = new Date();
      this.valueAsDate = this.innerValue;
      this.dateChanged.emit(this.innerValue);
    }

  }
}
